module.exports = __webpack_public_path__ + "static/7d-9a1013ce1a2a74dc04b515afe71ce0dc.png";